var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("搜索条件")])
          ]),
          _c(
            "temp-search",
            _vm._b(
              {
                ref: "ref_1000",
                attrs: {
                  "remote-func": _vm.remoteFunc,
                  "on-click-operate": _vm.onClickSearchOperate,
                  "on-condition-change": _vm.onConditionChange
                }
              },
              "temp-search",
              _vm.searchModel_1000,
              false
            )
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("董事审核列表")])
          ]),
          _c(
            "temp-table",
            _vm._b(
              {
                ref: "ref_1001",
                attrs: {
                  "remote-func": _vm.remoteFunc,
                  "req-table-data": _vm.reqTableData,
                  "req-add": _vm.reqAdd,
                  "req-del": _vm.reqDel,
                  "on-click-link": _vm.onClickLink,
                  "on-click-row-button": _vm.onClickRowButton,
                  "on-click-header-button": _vm.onClickHeaderButton,
                  "on-summary": _vm.onSummary,
                  "on-switch-change": _vm.onSwitchChange,
                  "on-row-button-show": _vm.onRowButtonShow
                }
              },
              "temp-table",
              _vm.tableModel_1001,
              false
            )
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }